import React from 'react';
import {
    Edit,TextInput , SimpleForm , SaveButton , Toolbar , BooleanInput, translate,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import { ReferenceImageInput, transformReferenceImage } from '../util/referenceImageHelper';

const MenuSurveyEditToolbar = translate(({ onCancel, translate, ...props }) => (
    <Toolbar {...props}>
        <SaveButton />
        <Button onClick={onCancel}>{translate('ra.action.cancel')}</Button>
    </Toolbar>
));
const MenuSurveyEdit = ({ onCancel, ...props }) => (
    <Edit title="  " {...props} transform={transformReferenceImage}>
        <SimpleForm toolbar ={<MenuSurveyEditToolbar onCancel={onCancel} />}>
            <BooleanInput source ='published' label="개제 On/Off" />
            <TextInput source="menuName" label="메뉴명" />
            {/* <ImageInput source="menuPhotoFile" label="???메뉴 섬네일" multiple={true} accept="image/*">
                <ImageField source="src" title="title" />
            </ImageInput> */}
            <ReferenceImageInput 
                label="메뉴 섬네일" source="menuFile" reference="uploadedFiles" preview="fullPath" addLabel
            />
            <TextInput source ='startDate' label="시작일" />
            <TextInput source ='endDate' label="종료일" />
            {/*  <TextInput source ='status' label="현재상태" hidden disabled /> 
             <TextInput source ='likeCount' label="좋아요 수" hidden disabled />  */}
        </SimpleForm>
    </Edit>
);

export default MenuSurveyEdit;
